import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1bd10ef0")
const _hoisted_1 = { class: "nav" }
const _hoisted_2 = { class: "flex place-content-between mb-2 text-custom-black-350" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("hr", { class: "gap" }, null, -1)
_popScopeId()

import { computed, reactive, ref, withDefaults } from 'vue';
import useNumbers from '@/composables/useNumbers';
import { useI18n } from 'vue-i18n';
import { TransactionActionInfo } from '@/types/transactions';
import useVeFlakeApprovalActions from '@/composables/useVeFlakeApprovalActions';
import useWeb3 from '@/services/web3/useWeb3';
import { DecoratedPool } from '@/services/balancer/subgraph/types';
import { TransactionResponse } from '@ethersproject/abstract-provider';
import BalActionSteps from '@/components/_global/BalActionSteps/BalActionSteps.vue';
import { bnum } from '@/lib/utils';
import { balancerService } from '@/services/balancer/balancer.service';
import useTransactions from '@/composables/useTransactions';
import useEthers from '@/composables/useEthers';
import useBalanceQuery from '@/composables/queries/useBalanceQuery';
import TokenGetBalanceInput from '@/components/inputs/TokenGetBalanceInput.vue';
import useUserInfosQuery from '@/composables/queries/useUserInfosQuery';

type Props = {
  pool: DecoratedPool;
  farmId: string;
};

export default _defineComponent({
  props: {
    pool: { type: null, required: true },
    farmId: { type: String, required: true }
  } as unknown as undefined,
  setup(__props: {
  pool: DecoratedPool;
  farmId: string;
}) {

const props = __props
const ACTIONTITLE = ['veFlake', 'Staked veFlake'];


const { t } = useI18n();
const { fNum2 } = useNumbers();
const { getProvider, appNetworkConfig } = useWeb3();
const { addTransaction } = useTransactions();
const { txListener } = useEthers();
const veFlakeBalanceQuery = useBalanceQuery(
  appNetworkConfig.addresses.veFlake || ''
);
const { data: userInfosQuery } = useUserInfosQuery({
  pid: props.farmId.split('_')[1]
});

/**
 * STATE
 */
const state = reactive({
  navCurIndex: 0,
  customSlippage: '',
  isCustomInput: false,
  inputAmount: '0'
});
const { tokenApprovalActions } = useVeFlakeApprovalActions(
  [appNetworkConfig.addresses.veFlake || ''],
  ref(['1'])
);
const allActions = computed(() => [
  {
    label: 'Boost',
    loadingLabel: 'Confirm boost in wallet',
    confirmingLabel: t('confirming'),
    action: () => boostDeposit(),
    stepTooltip: 'Confirm boost into this pool'
  },
  {
    label: 'Unboost',
    loadingLabel: 'Confirm unboost in wallet',
    confirmingLabel: t('confirming'),
    action: () => boostWithdraw(),
    stepTooltip: 'Confirm unboost into this pool'
  }
]);
const userInfos = computed(() =>
  userInfosQuery.value ? userInfosQuery.value[0] : undefined
);
const actions = computed((): TransactionActionInfo[] => {
  const currentAction = allActions.value.filter(
    (action, index) => state.navCurIndex === index
  );
  return [...tokenApprovalActions, ...currentAction];
});
const veFlakeBalance = computed(
  () => (veFlakeBalanceQuery.data.value as string) || '0'
);

const actionTitle = computed(() => ACTIONTITLE[state.navCurIndex]);
const actionTitleValue = computed(() => {
  let data = '';
  switch (state.navCurIndex) {
    case 0:
      data = veFlakeBalance.value
        ? // @ts-ignore
          bnum(veFlakeBalance.value || '0')
            .div(Math.pow(10, 18))
            .toString()
        : '0';
      break;
    case 1:
      data = userInfos.value
        ? // @ts-ignore
          bnum(userInfos.value.boostStaked || '0')
            .div(Math.pow(10, 18))
            .toString()
        : '0';
      break;
  }
  return data;
});

/**
 * METHOD
 */
const chooseNavIndex = index => {
  state.navCurIndex = index;
};
const handleInAmountChange = x => {
  state.inputAmount = x;
};

async function boostDeposit(): Promise<TransactionResponse> {
  const provider = getProvider();
  const pid = props.pool.pid as string;

  try {
    const formatAmount = bnum(state.inputAmount)
      .abs()
      .times(Math.pow(10, 18))
      .toString(16);
    const params = [pid, `0x${formatAmount}`];
    const tx = await balancerService.farmPools.normalFarm.boostDeposit(
      provider,
      params
    );

    addTransaction({
      id: tx.hash,
      type: 'tx',
      action: 'boostDeposit',
      summary: 'boostDeposit',
      details: {
        name: 'MyFarmPool'
      }
    });

    txListener(tx, {
      onTxConfirmed: async () => {
        // const poolDetails = await balancerService.pools.weighted.details(
        //   provider,
        //   tx
        // );
        // poolCreationState.poolId = poolDetails.id;
        // poolCreationState.poolAddress = poolDetails.address;
        // poolCreationState.needsSeeding = true;
        // saveState();
      },
      onTxFailed: () => {
        console.log('boostDeposit failed');
      }
    });

    return tx;
  } catch (e) {
    console.log(e);
    return Promise.reject('boostDeposit failed');
  }
}
async function boostWithdraw(): Promise<TransactionResponse> {
  const provider = getProvider();
  const pid = props.pool.pid as string;
  try {
    const formatAmount = bnum(state.inputAmount)
      .abs()
      .times(Math.pow(10, 18))
      .toString(16);
    const params = [pid, `0x${formatAmount}`];
    const tx = await balancerService.farmPools.normalFarm.boostWithdraw(
      provider,
      params
    );

    addTransaction({
      id: tx.hash,
      type: 'tx',
      action: 'boostWithdraw',
      summary: 'boostWithdraw',
      details: {
        name: 'MyFarmPool'
      }
    });

    txListener(tx, {
      onTxConfirmed: async () => console.log('boostWithdraw success'),
      onTxFailed: () => {
        console.log('boostWithdraw failed');
      }
    });

    return tx;
  } catch (e) {
    console.log(e);
    return Promise.reject('boostWithdraw failed');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalCard = _resolveComponent("BalCard")!

  return (_openBlock(), _createBlock(_component_BalCard, {
    shadow: "none",
    noBorder: "",
    changeType: "boost"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Boost', 'Unboost'], (item, index) => {
          return _createVNode(_component_BalBtn, {
            key: index,
            color: 
          _unref(state).navCurIndex === index ? 'custom-green-50' : 'custom-black-300'
        ,
            onClick: ($event: any) => (chooseNavIndex(index)),
            changeType: "boost",
            label: item,
            block: "",
            class: "font-ops"
          }, null, 8, ["color", "onClick", "label"])
        }), 64))
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_unref(actionTitle)), 1),
        _createElementVNode("span", null, _toDisplayString(_unref(fNum2)(_unref(actionTitleValue))), 1)
      ]),
      _createElementVNode("a", {
        class: _normalizeClass([_unref(state).navCurIndex === 0 ? 'visible' : 'invisible', "text-custom-black-350 text-sm mb-3"]),
        target: "_blank",
        href: `/#/stake-flake`
      }, " Get veFlake ", 2),
      _createVNode(TokenGetBalanceInput, {
        hasBar: true,
        barName: "Boosting Effect",
        changeType: _ctx.changeType,
        "onUpdate:amount": handleInAmountChange,
        modelValue: _unref(actionTitleValue),
        userInfos: _unref(userInfos),
        actionType: _unref(state).navCurIndex
      }, null, 8, ["changeType", "modelValue", "userInfos", "actionType"]),
      _hoisted_3,
      _createVNode(BalActionSteps, {
        showStep: false,
        actions: _unref(actions),
        changeType: "changeType",
        color: _ctx.color,
        showBtn: true
      }, null, 8, ["actions", "color"])
    ]),
    _: 1
  }))
}
}

})